import { Flex, Button } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import React from 'react';
import { toFormikValidationSchema } from 'zod-formik-adapter';

import {
  LoginFormValues,
  LoginFormValuesStruct,
} from '~/contexts/UserAuthProvider/requests/login';
import { InputFormField } from '~/packages/common-frontend/components/FormField';

// Constants
const FORM_ID = 'LoginForm';
const INITIAL_VALUES: LoginFormValues = {
  email: '',
  password: '',
};

// Exports
type LoginFormProps = { onSubmit: (formValues: LoginFormValues) => void };
export const LoginForm = ({ onSubmit }: LoginFormProps) => (
  <Formik
    validationSchema={toFormikValidationSchema(LoginFormValuesStruct)}
    initialValues={INITIAL_VALUES}
    onSubmit={onSubmit}
  >
    {(formProps) => (
      <Flex as={Form} id={FORM_ID} direction="column" gap="1.5rem">
        <InputFormField
          isRequired
          propName="email"
          type="email"
          formProps={formProps}
          label="Email"
          placeholder="Email Address"
          inputWidth="lg"
        />
        <InputFormField
          isRequired
          propName="password"
          type="password"
          label="Password"
          placeholder="Password"
          inputWidth="lg"
          formProps={formProps}
        />
        <Button
          data-testid="LoginForm.submit"
          type="submit"
          variant="primary"
          colorScheme="v2-aurora"
          width="full"
          isLoading={formProps.isSubmitting}
        >
          Sign in to Finley
        </Button>
      </Flex>
    )}
  </Formik>
);
